import { createFileRoute } from "@tanstack/react-router";
import { ServiceAreaWebDesignPage, serviceAreaHead } from "@/components/ServiceAreaWebDesignPage";
import { SERVICE_AREAS } from "@/lib/serviceAreaWebDesign";

const AREA = SERVICE_AREAS["western-slope"];

export const Route = createFileRoute("/web-design-western-slope-colorado")({
  head: () => serviceAreaHead(AREA),
  component: () => <ServiceAreaWebDesignPage area={AREA} />,
});
